export const filterTokens = {
  minColumnWidth: 180,
  labelOffsetX: 10,
  labelOffsetY: 9,
  inputPaddingLeft: 8,
  selectPaddingLeft: 2,
  dateInputPaddingLeft: 4,
  controlMinHeight: 36,
} as const;
